/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ui/NG_NEXT_PREV': {
    width: 16,
    height: 16,
    viewBox: '0 0 17 30',
    data: '<path pid="0" _fill="#545454" d="M16.56 15L1.85.3.44 1.71 13.73 15 .44 28.29l1.41 1.41L16.56 15z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/ui/NG_NEXT_PREV.js